import WorksJAMeta from './works_ja.json';
import createPocketBaseWorksLoader from './pocketbase';

// Collection names are code/data contracts, not deployment environment settings.
const loadWorksJA = createPocketBaseWorksLoader({
  collection: 'works',
  lang: 'ja',
});

export { WorksJAMeta };

export default loadWorksJA;
